import { ReactNode } from 'react';

import { T } from 'utils/i18n';

// export type UserRoleValue = 0 | 1 | 2;

export enum UserRoleValue {
    WRITER = 0,
    READER = 1,
    ADMIN = 2
};

export type UserRole = {
    value: UserRoleValue,
    title: ReactNode,
    description: ReactNode
};

const userRoles: UserRole[] = [{
    value: 0,
    title: <T label="Editor" />,
    description: <T label="Pode visualizar e alterar o projeto" />
}, {
    value: 1,
    title: <T label="Leitor" />,
    description: <T label="Pode apenas visualizar o projeto" />
}, {
    value: 2,
    title: <T label="Administrador" />,
    description: <T label="Pode editar o projeto e administrar usuários" />
}];

export default userRoles;
